import { UpdateSuperAdminUserRequestSchema, UpdateSuperAdminUserResponseSchema } from './update-superadmin-user.schema';
/**
 * Update SuperAdmin User Endpoint Contract
 * Updates an existing superadmin user's details
 */ export const updateSuperAdminUserContract = {
    method: 'PATCH',
    path: '/api/v2/superadmin-users/:userId',
    description: "Update an existing superadmin user's details",
    requestSchema: UpdateSuperAdminUserRequestSchema,
    responseSchema: UpdateSuperAdminUserResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad request - invalid user data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'Not found - user does not exist'
        }
    }
};

//# sourceMappingURL=update-superadmin-user.contract.js.map